import ChallengeHub from './ChallengeHub';

export default ChallengeHub;
